import { Col, Row } from "react-bootstrap";
import classNames from "classnames";
import url from "../../module/fetch.tsx";
import { useGet } from "../../components/Fetch/useFetch.tsx";
import styles from "./AccueilAdmin.module.css";
const AccueilAdmin = () => {
  const stats = useGet(url`/api/exportLogConnexion/adminStats`, {});

  return (
    <Row>
      <Col
        xs={"auto"}
        className={classNames(
          "my-3 text-text-color bg-light text-center p-3 rounded-5 mx-5 d-flex flex-column justify-content-center align-items-center",
          styles.mainCard,
        )}
      >
        <h3 className={"text-uppercase"}>Nombre d&apos;utilisateurs</h3>
        <div className={"text-primary mt-2"}>{stats?.data?.nbUtilisateur}</div>
      </Col>
      <Col sm={12} lg={"auto"} className={"p-3"}>
        <Row>
          <h2 className={"connexion-h2 text-uppercase"}>Durées de connexion</h2>
        </Row>
        <Row className={classNames(styles.statsCard, "mt-2")}>
          <Col
            className={classNames(
              styles.backgroundWhite,
              "text-text-color rounded-5 mx-3 p-3 p-lg-4 bg-light",
            )}
          >
            <h3 className={"text-uppercase text-nowrap"}>Moyenne mensuelle</h3>
            <div className={"text-secondary-100"}>
              {stats?.data?.averageSession}
            </div>
          </Col>
          <Col
            className={classNames(
              styles.backgroundWhite,
              "text-text-color rounded-5 p-3 p-lg-4 mx-3 bg-light",
            )}
          >
            <h3 className={"text-uppercase text-nowrap"}>La plus longue</h3>
            <div className={"text-secondary-100"}>
              {stats?.data?.longestSession}
            </div>
          </Col>
          <Col
            className={classNames(
              styles.backgroundWhite,
              "text-text-color rounded-5 p-3 p-lg-4 mx-3 bg-light",
            )}
          >
            <h3 className={"text-uppercase text-nowrap"}>La plus courte</h3>
            <div className={"text-secondary-100"}>
              {stats?.data?.shortestSession}
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
AccueilAdmin.propTypes = {};

export default AccueilAdmin;
